import { AlphaHCircleIcon } from './AlphaHCircleIcon';

/**
 * author: Contributors
 * id FC1C719F-CE44-4B8A-A2A8-5DE6E02405D2
 * name alpha-h-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-h-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetHCircleIcon = AlphaHCircleIcon;
export default AlphabetHCircleIcon